import React from 'react';
import {SvgIcon} from '@material-ui/core';


export default function WarningIcon(props) {
    return (
        <SvgIcon width="31" height="31" viewBox="0 0 31 31" {...props}>
            <g fill="none" fillRule="evenodd">
                <path fill="#FF5F77" d="M14.76 0C6.608 0 0 6.609 0 14.76c0 8.15 6.609 14.759 14.76 14.759 8.15 0 14.759-6.609 14.759-14.76C29.519 6.61 22.91 0 14.759 0z" transform="translate(.24 .24)" />
                <path fill="#FFF" d="M14.775 18.976c1.164 0 2.109.945 2.109 2.109 0 1.164-.945 2.108-2.109 2.108-1.163 0-2.108-.944-2.108-2.108 0-1.164.945-2.109 2.108-2.109zM14.76 5.003c1.144 0 2.072.928 2.072 2.072v.036l-.14 7.898c-.018 1.032-.86 1.859-1.892 1.859-1.034 0-1.88-.825-1.905-1.86l-.192-7.897c-.027-1.136.871-2.08 2.007-2.107h.05z" transform="translate(.24 .24)" />
            </g>
        </SvgIcon>
    )
}



// WEBPACK FOOTER //
// ./src/components/controls/icons/WarningIcon.jsx